import ChipSlim from "./ChipSlim";

export default ChipSlim;